export default "__VITE_ASSET__BsKnkNBT__"